// src/ui/AppToast.jsx
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTheme } from "../context/ThemeContext";
import { createPortal } from "react-dom";

export default function AppToast() {
  const { isDarkMode } = useTheme();

  const htmlDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");
  const prefersDark =
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
  const isDark = (isDarkMode ?? htmlDark ?? prefersDark) ? true : false;

  if (typeof document === "undefined") return null;

  return createPortal(
    <ToastContainer
      containerId="global"
      theme="colored"
      position="bottom-right"
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
      style={{
        // aivan kaiken yläpuolelle (myös z-[9999] -verhojen)
        zIndex: 2147483647,
        // uudemmat react-toastify-versiot lukevat tämän muuttujan
        "--toastify-z-index": 2147483647,
        bottom: "88px", // tilaa sticky action barille
        "--toastify-color-success": isDark ? "#00B8FF" : "#FF2D95",
        "--toastify-text-color-success": "#000",
        "--toastify-text-color-info": "#000",
        "--toastify-text-color-warning": "#000",
        "--toastify-text-color-error": "#000",
      }}
      // vaihtoehtoisesti: className="!z-[2147483647]"
    />,
    document.body
  );
}
